export {setGlobalOptions as setLoaderOptions} from '../loader-utils/option-utils';
export {getGlobalLoaderOptions as getLoaderOptions} from '../loader-utils/option-utils';
